module.exports = __webpack_public_path__ + "/assets/img/icon_add_comment919f9f1c.svg";